import { render } from "./BaseDropdownContent.vue?vue&type=template&id=578420d4&scoped=true"
import script from "./BaseDropdownContent.vue?vue&type=script&lang=js"
export * from "./BaseDropdownContent.vue?vue&type=script&lang=js"

import "./BaseDropdownContent.vue?vue&type=style&index=0&id=578420d4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-578420d4"]])

export default __exports__